import React from "react";
import returnColor from "src/utils/returnColor";
import SortableItem from "src/components/Sortable/Item";
import { PermissionEnum } from "src/context/Auth/interface";
import { useAuth } from "src/context/Auth/context";
import Container from "../Container";
import { ColumnKanban } from "../../kanbanModes/MultipleKanbans/interface";

interface ISortableColumn{
	idColumn: string;
	disabled?: boolean;
	columnsData: ColumnKanban;
  style?: React.CSSProperties;
	children: React.ReactNode;
  columns?: number;
  label?: string;
  horizontal?: boolean;
  hover?: boolean;
  handleProps?: React.HTMLAttributes<any>;
  scrollable?: boolean;
  shadow?: boolean;
  placeholder?: boolean;
	noStyle?: boolean;
	onChangeColorColumn?: Function;
	onChangeTitleColumn?: Function;
  unstyled?: boolean;
  onRemove?: Function;
	onClick?(): void;
	numberOfItems?: number;
	isDefaultColumn?: boolean;
	permission?: number;
}

const DroppableContainer: React.FC<ISortableColumn> = ({
	children,
	columns = 1,
	disabled,
	columnsData,
	idColumn,
	placeholder,
	noStyle,
	onChangeColorColumn,
	onChangeTitleColumn,
	onRemove,
	numberOfItems,
	isDefaultColumn = false,
	onClick,
	permission = 2
}) => {

	const { superUser, administrator, checkIfHasSpecificPermission } = useAuth();

	const colorChange = (newColor: string) => {
		if(onChangeColorColumn)
			onChangeColorColumn(idColumn, newColor);
	};

	const titleChange = (newTitle: string) => {
		if(onChangeTitleColumn)
			onChangeTitleColumn(idColumn, newTitle);
	};

	const onRemoveColumn = () => {
		if(onRemove)
			onRemove(idColumn);
	};

	return (
		<>  
			<SortableItem
				id={idColumn}
				disabled={disabled || !((superUser || administrator || permission >= 2) && checkIfHasSpecificPermission("actions/kanban", PermissionEnum.CREATE_UPDATE))}
				styles={{ 
					width: isDefaultColumn ? "100%" : "",
					margin: isDefaultColumn ? "10px" : "" 
				}}
			>
				<Container 
					placeholder={placeholder}
					onClick={onClick}
					numberOfItems={numberOfItems ?? 0}
					label={columnsData && columnsData.kba002Descricao ? columnsData.kba002Descricao:  ""}
					onChangeColorColumn={colorChange}
					onChangeTitleColumn={titleChange}
					color={columnsData && columnsData.kba002Cor ? returnColor(columnsData.kba002Cor) : "#d3d3d3"}
					onRemove={() => onRemoveColumn()}
					columns={columns}
					noStyle={noStyle}
					isDefaultColumn={isDefaultColumn}
					permission={permission}
				>
					{children}
				</Container>
			</SortableItem>
		</>
	);
};

export default DroppableContainer;
